export default __webpack_public_path__ + "static/media/brigada-eskwela.3547147f.png";